
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    IcoEndoso: () => import("@/views/admin/dashboard/icons/IcoEndoso.vue"),
    IcoEndosoMov: () =>
      import("@/views/admin/dashboard/icons/IcoEndosoMov.vue"),
    IcoSiniestro: () =>
      import("@/views/admin/dashboard/icons/IcoSiniestro.vue"),
    IcoSolicitud: () => import("@/views/admin/dashboard/icons/IcoSolicitud.vue"),
    IcoSolicitudRechazada: () => import("@/views/admin/dashboard/icons/IcoSolicitudRechazada.vue")
  }
})
export default class Icon extends Vue {
  @Prop(String) readonly selectedIcon: string;
  @Prop(String) readonly width: string;
  @Prop(String) readonly height: string;
}
